import graphql__668da64e6251525987ab from "./__generated__/FooterManagerQuery.graphql.js";import { useCallback, useEffect, useRef, useState } from "react";
import { graphql } from "react-relay";
import { useSelector } from "react-redux";
import AppQueryRenderer from "../AppQueryRenderer";

import Footer from "./Footer";
import { useFixedActionButtons } from "../FixedActions/FixedActionButtonsContext";
import { NonDesktop } from "../Utils/ResponsiveQueries";

const FooterManager = props => {
  const { mainContent } = props;
  const [isFixed, setIsFixed] = useState(false);
  const wrapperRef = useRef();

  const iFrameMode = useSelector(({ styling }) => styling.iFrameMode);
  const fullScreenMode = useSelector(({ styling }) => styling.fullScreenMode);

  const { setFixedActionsPlaceholder } = useFixedActionButtons();

  const updatePosition = useCallback(() => {
    if (!mainContent || !wrapperRef.current) return;

    const mainContentHeight = mainContent.offsetTop + mainContent.clientHeight;
    // We add a safe-navigation operator here as there seems that the ref can be unset
    // between the above check and the execution of this line. This seems weird, but
    // happened
    const wrapperHeight = wrapperRef.current?.clientHeight || 0;
    const viewportHeight = window.innerHeight;

    const shouldBeFixed = mainContentHeight + wrapperHeight < viewportHeight;
    if (shouldBeFixed === isFixed) return;

    setIsFixed(shouldBeFixed);
  }, [isFixed, mainContent]);

  useEffect(() => {
    if (typeof setInterval === "undefined") return;

    const refreshTimer = setInterval(updatePosition, 50);

    return () => {
      if (!refreshTimer) return;
      clearInterval(refreshTimer);
    };
  }, [updatePosition]);

  const style = isFixed
    ? {
        position: "absolute",
        bottom: 0,
        width: "100%"
      }
    : null;

  const displayFooter = !fullScreenMode && !iFrameMode;

  return (
    <div className="footer-wrapper" ref={wrapperRef} style={style} data-footer-container>
      <NonDesktop>
        <div className="fixed-actions-placeholder" ref={setFixedActionsPlaceholder} />
      </NonDesktop>

      {displayFooter && (
        <footer role="contentinfo" className="main-footer bg-primary">
          <AppQueryRenderer
            query={FooterManagerQuery}
            component={Footer}
            additionalProps={props}
            handleErrors={false}
          />
        </footer>
      )}
    </div>
  );
};

const FooterManagerQuery = graphql__668da64e6251525987ab;

export default FooterManager;
